import { BASE_CORE_URL, BASE_URL, AUTH_CODE, AUTH_TOKEN, UAPI_URL_CONFIG, UAPI_URL_AUTH } from './../config/index'

export const Getuserslist = async (obj) => {
    let url;
    let requestOptions;
      url = BASE_CORE_URL + "User/Get"
      requestOptions = {
        method: "GET",
        headers: { 
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken'),
        "Content-Type": "application/json"
        },
      }
    return await fetch(url, requestOptions)
        .then((resp) => {
          return resp.json()
        })
        .then(function (data) {
        return data;
        })
        .catch(function (error) {
        console.error("userconfigcrud() Exception: ", error);
        });
}


export const GetNewUsersList = async(Id) =>{
  let url;
  let requestOptions;
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
   url = UAPI_URL_CONFIG + "user/getAllUsers?UserId=" + loggedInUser?.Id;
    requestOptions = {
      method: "GET",
      headers: { 
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken'),
      "Content-Type": "application/json"
      },
    }
    return await fetch(url, requestOptions)
        .then((resp) => {
          return resp.json()
        })
        .then(function (data) {
        return data;
        })
        .catch(function (error) {
        console.error("userconfigcrud() Exception: ", error);
    });

}

export const getAllActiveUsers = async(alertId) =>{
  let url;
  let requestOptions;
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
   url = UAPI_URL_CONFIG + "user/getAllActiveUsers?userId=" + loggedInUser?.Id + "&alertId=" + alertId;
    requestOptions = {
      method: "GET",
      headers: { 
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken'),
      "Content-Type": "application/json"
      },
    }
    return await fetch(url, requestOptions)
        .then((resp) => {
          return resp.json()
        })
        .then(function (data) {
        return data;
        })
        .catch(function (error) {
        console.error("userconfigcrud() Exception: ", error);
    });

}

export const createNewUser = async (obj) => {
    let url;
    let requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')  
      },
      body: JSON.stringify(obj),
    }
    url = BASE_CORE_URL + "User/Add";  
    
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("registeruserwithprivileges () Exception: ", error);
      });
  }

  //Fast API for new user
  export const createNewUserAdd = async (obj) => {
    let url;
    let requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')  
      },
      body: JSON.stringify(obj),
    }
    url = UAPI_URL_AUTH + "Add";     
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("registeruserwithprivileges () Exception: ", error);
      });
  }
//Fast API for new user 


  export const registerEmailUser = async (obj) => {
    let url;
    let requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')  
      },
      body: JSON.stringify(obj),
    }
    url = UAPI_URL_CONFIG + "user/registerEmailByUser";
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("registeremailuser () Exception: ", error);
      });
  }

  export const updateUser = async (obj) => {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(obj),
    };
    let url;   
      url = BASE_CORE_URL + "User/Update";
      requestOptions.headers = {
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken'),
      "Content-Type": "application/json"
      }
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("updateprivilegeduser() Exception: ", error);
      });
  }

  export const updateUserNew = async (obj) => {
    const requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')  
      },
      body: JSON.stringify(obj),
    };
      let url;   
      url = UAPI_URL_AUTH + "Update";
      return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("updateprivilegeduser () Exception: ", error);
      });
  }

  export const GetPrivilegeGroupList = async (userId) => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      //body: JSON.stringify({ "UserID": userId })
    };
  return null;
    let url = BASE_URL + "getprivilegegrouplist?UserID=" + userId;
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("getprivilegegrouplist () Exception: ", error);
      });
  }

  export const deleteUser = async (userId) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ UserID: userId }),
    };
  return null;
    let url = BASE_URL + "deleteprivilegeduser ";
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("deleteprivilegeduser () Exception: ", error);
      });
  }

  export const GetUserProfileInfoDotNet = async() => {
    const requestOptions = {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
      }
    }
    let url = UAPI_URL_CONFIG + "user/getUserByAuthCode?" + new URLSearchParams({
      authCode: localStorage.getItem('authCode')
    });
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(data => {
        return data;
      }).catch(function (error) {
        console.error("GetUserProfileInfo () Exception: ", error);
      });
  }

  export const GetUserProfileInfoDotNetTemp = async(authCode,authToken) => {
    const requestOptions = {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        // "authcode": localStorage.getItem('authCode'),
        // "Authorization": "Bearer " + localStorage.getItem('authToken')
        "authcode": authCode,
        "Authorization": "Bearer " + authToken
      }
    }
    let url = UAPI_URL_CONFIG + "user/getUserByAuthCode?" + new URLSearchParams({
      authCode: localStorage.getItem('authCode')
    });
    
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(data => {
        return data;
      }).catch(function (error) {
        console.error("GetUserProfileInfo () Exception: ", error);
      });
    }
    
    export const GetUserProfileInfo = async (useruniqueid) => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
  return null;
    let url = BASE_URL + "getuserdetails/?useruniqueid=" + useruniqueid;
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error("GetUserProfileInfo () Exception: ", error);
      });
  }

  export const userGroupAndSiteGroupCRUD = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
    };
return null;
    let url = BASE_URL + "usergroupandsitegroupcrud";
    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
        return data;
        })
        .catch(function (error) {
        console.error("usergroupandsitegroupcrud() Exception: ", error);
        });
}

// export const Getsitelist = async () => {
//     let userid = localStorage.getItem('UserID');
//     const requestOptions = {
//       method: "GET",
//       headers: { "Content-Type": "application/json" },
//     };
  
//     let url = BASE_URL + "getsitelist?UserID=" + userid;
//     return await fetch(url, requestOptions)
//       .then((resp) => {
//         // console.log("site details resp", { resp });
//         return resp.json();
//       })
//       .then(function (data) {
//         // console.log("getsitelist () Data: ", data);
//         return data;
//       })
//       .catch(function (error) {
//         console.error("getsitelist () Exception: ", error);
//       });
// }

//#region user role list
export const GetUserRoleList = async (obj) => {
    const requestOptions = {
      method: "POST",
      headers:{ 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem("authCode"),
        "Authorization": "Bearer " + localStorage.getItem("authToken"),
      },
      body: JSON.stringify(obj),
    };
    let url = UAPI_URL_CONFIG + "masters/getMasterData";
    //console.log("api url", url)
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error(error);
      });
}
//#endregion

//#region user-role module list
export const GetModuleList = async (obj) => {
  const requestOptions = {
    method: "GET",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = UAPI_URL_CONFIG + "userRoles/getMenuMaster";
  //console.log("Module====", url)
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
}
//#endregion


//#region Api Calling for Getting UserRoleList
export const getRoleNameList = async (Id, userId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken')
    },
  };
  let url = UAPI_URL_CONFIG + `userRoles/getUserRolesById?id=${Id}&userId=`+localStorage.getItem('UserID')
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getRoleNameList () Exception: ", error);
    });
}
//#endregion


//Fast API for new userRole
export const createNewUserRole = async (obj) => {
  let url;
  let requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken')  
    },
    body: JSON.stringify(obj),
  }
  url = UAPI_URL_CONFIG + "userRoles/addUserRoles";     
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("adduserroles () Exception: ", error);
    });
}
//Fast API for new user 

//Fast API for update userRole
export const updateUserRole = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken')  
    },
    body: JSON.stringify(obj),
  };
  let url;   
    url = UAPI_URL_CONFIG + "userRoles/updateUserRoles";
    return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("updateuserroles () Exception: ", error);
    });
}
//Fast API for update userRole

//#region user-role module list
export const getMenuFunctions = async (userRoleId, menuId) => {
  const requestOptions = {
    method: "GET",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
  };
  // http://127.0.0.1:8001/api/config/userRoles/getMenuFunction?userRoleId=2&menuId=3
  let url = UAPI_URL_CONFIG + "userRoles/getMenuFunction?userRoleId=" + userRoleId + "&menuId=" + menuId;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
}
//#endregion
